// extracted by mini-css-extract-plugin
module.exports = {"screen":"Content_screen__2tbxm"};